import Api from '../services/api.js'

export function createEmailRecipientRequest(){
  return {
    type: 'CREATE_EMAIL_RECIPIENT_REQUEST',
  }
}

export function createEmailRecipientSuccess(body){
  return {
    type: 'CREATE_EMAIL_RECIPIENT_SUCCESS',
    body: body
  }
}

export function createEmailRecipientFailure(exception){
  return {
    type: 'CREATE_EMAIL_RECIPIENT_FAILURE',
    exception: exception
  }
}

export function createEmailRecipient(params) {
  return dispatch => {
    dispatch(createEmailRecipientRequest())
    const api = new Api();
    return api.makeRequest({
        method: "post",
        url: `/api/v1/email_recipients`,
        params: params
      })
      .then(response => {
        dispatch(createEmailRecipientSuccess(response.data))
      })
      .catch(err => {
        // error callback
        dispatch(createEmailRecipientFailure(err))
      })
  }
}


export function updateEmailRecipientRequest(){
  return {
    type: 'UPDATE_EMAIL_RECIPIENT_REQUEST',
  }
}

export function updateEmailRecipientSuccess(body){
  return {
    type: 'UPDATE_EMAIL_RECIPIENT_SUCCESS',
    body: body
  }
}

export function updateEmailRecipientFailure(exception){
  return {
    type: 'UPDATE_EMAIL_RECIPIENT_FAILURE',
    exception: exception
  }
}

export function updateEmailRecipient(params) {
  return dispatch => {
    dispatch(updateEmailRecipientRequest())
    const api = new Api();
    return api.makeRequest({
        method: "put",
        url: `/api/v1/email_recipients`,
        params: params
      })
      .then(response => {
        dispatch(updateEmailRecipientSuccess(response.data))
      })
      .catch(err => {
        // error callback
        dispatch(updateEmailRecipientFailure(err))
      })
  }
}


// WEBPACK FOOTER //
// ./src/actions/email_recipients.js